import { useEffect, useState } from 'react'

/** `value`, but only after it has stopped changing for `ms` — a search box
 *  that asks the server once the typing pauses. */
export function useDebounced<T>(value: T, ms = 300): T {
  const [out, setOut] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setOut(value), ms)
    return () => clearTimeout(t)
  }, [value, ms])
  return out
}
